/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_NoteInputs */

const en_us2_recovery_note = /** @type {(inputs: Recovery_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An estimate from your sets and your soreness check-in alone. Sleep, stress and food are not part of it.`)
};

const pt_br2_recovery_note = /** @type {(inputs: Recovery_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma estimativa feita só com as suas séries e o check-in de dor. Sono, estresse e alimentação não entram na conta.`)
};

const es_419_recovery_note = /** @type {(inputs: Recovery_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una estimación hecha solo con tus series y tu registro de dolor. El sueño, el estrés y la alimentación no entran en la cuenta.`)
};

const pt_pt2_recovery_note = /** @type {(inputs: Recovery_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma estimativa feita apenas com as tuas séries e o registo de dores. O sono, o stress e a alimentação não entram na conta.`)
};

const fr_fr2_recovery_note = /** @type {(inputs: Recovery_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une estimation basée uniquement sur tes séries et ton bilan de courbatures. Le sommeil, le stress et l'alimentation n'en font pas partie.`)
};

const de_de2_recovery_note = /** @type {(inputs: Recovery_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Schätzung nur aus deinen Sätzen und deinem Muskelkater-Check-in. Schlaf, Stress und Ernährung fließen nicht ein.`)
};

const it_it2_recovery_note = /** @type {(inputs: Recovery_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una stima basata solo sulle tue serie e sul check-in dei dolori. Sonno, stress e alimentazione non sono inclusi.`)
};

/**
* | output |
* | --- |
* | "An estimate from your sets and your soreness check-in alone. Sleep, stress and food are not part of it." |
*
* @param {Recovery_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_note = /** @type {((inputs?: Recovery_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_note(inputs)
	if (locale === "es-419") return es_419_recovery_note(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_note(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_note(inputs)
	if (locale === "de-DE") return de_de2_recovery_note(inputs)
	if (locale === "it-IT") return it_it2_recovery_note(inputs)
	return en_us2_recovery_note(inputs)
});
export { recovery_note as "recovery.note" }